export class UserDataModel {

    public name: string;
    public lastname1: string;
    public lastname2: string;
    public email: string;
    public phone1: string;
    public phone2: string;
    public currentCompany: string;
    public coverage: string;
    public specSheet: string;
    public driverIdentification: string;
    public license: string;
    public checkPrivacy: boolean;
    public checkCalling: boolean;

  constructor(obj: {
    coverage: string | '';
    currentCompany: string | '';
    name: string | '';
    phone2: string | '';
    lastname2: string | '';
    lastname1: string | '';
    email: string | '';
    phone1: string | '';
    specSheet: string | '';
    driverIdentification: string | '';
    license: string | '';
    checkPrivacy: boolean | false;
    checkCalling: boolean | false;
  }) {
        this.name = obj && obj.name || '';
        this.lastname1 = obj && obj.lastname1 || '';
        this.lastname2 = obj && obj.lastname2 || '';
        this.email = obj && obj.email || '';
        this.phone1 = obj && obj.phone1 || '';
        this.phone2 = obj && obj.phone2 || '';
        this.currentCompany = obj && obj.currentCompany || '';
        this.coverage = obj && obj.coverage || '';
        this.specSheet = obj && obj.specSheet || '';
        this.driverIdentification = obj && obj.driverIdentification || '';
        this.license = obj && obj.license || '';
        this.checkPrivacy = obj && obj.checkPrivacy || false;
        this.checkCalling = obj && obj.checkCalling || false;
    }

}

